import { Component, NgZone } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { I18nService } from '../app/BaseFramework/core/services/i18n/i18n.service'
import { ThreadsService } from '../app/BaseFramework/core/utilities/threads.service'
import { AppMetadataHandler } from '../app/BaseFramework/configs/app-metadata.handler'
import { environment } from 'environments/environment';
import { HttpParams } from '@angular/common/http';
import { AuthenticationService } from './BaseFramework/core/authentication/authentication.service';
import { UserInfoService, LoginInfoInStorage } from './BaseFramework/core/http/user-info.service';
import { ApiRequestService } from './BaseFramework/core/http/api-request.service';
import { Subject } from 'rxjs';
import * as SecureLS from 'secure-ls';
import { SecureStorageService } from './BaseFramework/core/utilities/secure-storage.service';
import { NzIconService } from 'ng-zorro-antd/icon';
import { StorageManagement } from './BaseFramework/core/utilities/storage-management.service';

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

export interface LoginRequestParam {
  userId: string;
  password: string;
}

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class GlobalAppComponent {
  title = 'MetamorphosysBaseFramework';


  constructor(

    private i18nService: I18nService,
    public appMetadataHandler: AppMetadataHandler,
    private cdRef: ChangeDetectorRef,
    private threadsService: ThreadsService,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private apiRequestService: ApiRequestService,
    private nzIconService: NzIconService,
    private userInfoService: UserInfoService,
    private secureStorageService: SecureStorageService,
    private storageManagement: StorageManagement
  ) {
    // if (environment.production) {
    //   this.ngZone.onError.subscribe((e) => {
    //     let c: any = new Date()
    //     localStorage.setItem(c, e)
    //   });
    // }
  }
  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['guid']) {
        let paramValue = params['guid'];
      }else{
        localStorage.clear;
        // Get all the remaining URL parameters
        const url = window.location.href;
        const urlParts = url.split('?');
        localStorage.setItem('returnUrl', urlParts[0]);
        if (urlParts.length > 1) {
          const queryString = urlParts[1];
          const queryParams = new HttpParams({ fromString: queryString });
          const allParams = queryParams.keys();
          allParams.forEach(param => {
            // Store the parameter value in local storage
            try {
              localStorage.setItem(param, queryParams.get(param));
            } catch (error) {
              console.error('Error storing parameter in local storage:', error);
            }
          });
        }
      }
    });

    let token = this.getTokenFromURLOrStorage('LGT');
    // Example: baseURL/?token=398274983274jdhsf8732d82dn 
    if (environment['enableCheckTokenAndLogin'])
      this.CheckTokenAndLogin(token);

    this.threadsService.APPLICATIONBOOTSTRAPTHREAD().subscribe({
      next: (resp) => {
        if (resp['status']) {
          this.threadsService._successThreadLog('Application Has Started');
        } else {
          this.threadsService._errorThreadLog('There is some problem starting Application');
        }
      },
      error: (error) => {
        console.error('Application bootstrap error:', error);
        this.threadsService._errorThreadLog('Critical error during application bootstrap: ' + (error.message || 'Unknown error'));
      }
    });
  }

  private getTokenFromURLOrStorage(key) {
    let tokenFromURL = this.getQueryStringValOf(key);
    let tokenFromStorage
    if (!tokenFromURL) {
      tokenFromStorage = this.storageManagement.get(key).value
      return tokenFromStorage ? tokenFromStorage.replace(/['"]+/g, '') : tokenFromStorage
    } else {
      return tokenFromURL
    }
  }

  private CheckTokenAndLogin(token) {
    let logged = { receivedToken: token };
    try {
      this.storageManagement.store('LGT', token);
    }
    catch { }

    let resourceContext = environment['resourceContext'] || '/'
    this.nzIconService.changeAssetsSource(resourceContext);
    if (token) {
      this.authenticationService.loadingFromToken = true;
      let loginDataSubject: Subject<any> = new Subject<any>();
      let updateURL = 'fetchUserDetails';
      this.apiRequestService.token = token;
      try { this.secureStorageService.set('AutoLoginToken', token); }
      catch { }
      this.apiRequestService.getCallWithAPIMapper(updateURL)
        .subscribe(jsonResp => {
          console.log(jsonResp);
          let returnObj = jsonResp;
          setTimeout(() => {
            this.authenticationService.loadingFromToken = false;
          }, 10000);
          try { this.secureStorageService.set('AutoLoginResponse', JSON.stringify(jsonResp)); }
          catch { }
          let loginInfoReturn: LoginInfoInStorage = {
            "success": false,
            "message": "Unsuccessful login",
            "landingPage": "/login",
            "user": {
              "userId": null,
              "firstName": null,
              "email": null,
              "displayName": null,
              "token": null,
              "oneTimePasswordFl": false,
              "statusCd": null,
              "typeCd": null,
              "userRoleDOList": [],
              "userObjectResp": null
            }
          };


          let bodyData: LoginRequestParam = {
            "userId": jsonResp.userId,
            "password": jsonResp.password
          };


          //Fill in the success object that we want to send back to login page
          loginInfoReturn.success = true;
          loginInfoReturn.message = jsonResp.Message;
          loginInfoReturn.landingPage = "/app/dash";
          loginInfoReturn.user.userId = jsonResp.userId;
          loginInfoReturn.user.firstName = jsonResp.firstName;
          loginInfoReturn.user.email = jsonResp.emailId;
          loginInfoReturn.user.displayName = jsonResp.firstName;
          loginInfoReturn.user.oneTimePasswordFl = jsonResp.oneTimePasswordFl;
          loginInfoReturn.user.statusCd = jsonResp.statusCd;
          loginInfoReturn.user.typeCd = jsonResp.typeCd;
          loginInfoReturn.user.userRoleDOList = jsonResp.userRoleDOList;

          //Pentest Caution: Might be a Pentest Issue
          loginInfoReturn.user.token = this.apiRequestService.token;

          // store userId and jwt token in session storage to keep user logged in between page refreshes
          this.userInfoService.storeUserInfo(JSON.stringify(jsonResp));

          let credentials = { username: loginInfoReturn.user.userId, password: null };
          this.authenticationService._loginSuccessHandler(loginInfoReturn, credentials, this.appMetadataHandler.getEntryPoint(), null);

        }, errResp => {
          this.authenticationService.loadingFromToken = false;
        });

    }
    else {
      this.authenticationService.loadingFromToken = false;
      console.log("Not found");
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  getQueryStringValOf(paramName): string {
    const url = window.location.href;
    let paramValue: string | null | undefined;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }

  getEmptyLoginInfo(userId) {
    var loginInfoReturn = {
      "success": false,
      "message": "Unsuccessful login",
      "landingPage": "/login",
      "user": {
        "userId": userId,
        "firstName": null,
        "email": null,
        "displayName": null,
        "token": null,
        "oneTimePasswordFl": false,
      }
    };

    return loginInfoReturn
  }
}
